const navBarData = [
    { url: '#reasons', title: 'O nama' },
    { url: '#testemonials', title: 'Preporuke' },
    { url: '#programs', title: 'Programi' },
    { url: '#plans', title: 'Cenovnik' },
    { url: '#gallery', title: 'Galerija' },
    { url: '#newsletter', title: 'Kontakt' }
  ];
  
  export default navBarData;